import { Product } from "src/features/products/model/Product";
import { ProductBasic } from "src/features/products/model/ProductBasic";
import getProductDiscountPercantage from "src/shared/util/get-product-discount-percentage";
import { thumbnail } from "./thumbnail";

export function getProductDetails(product: Product): ProductBasic {
  const percentageToString = getProductDiscountPercantage(
    product.price,
    product.retailPrice
  );

  const details = {
    ...product,
    productPk: product.omniwebId,
    productImage: thumbnail(
      product?.productimageSet?.[0]?.url,
      "product-live-comm"
    ),
    productDiscount: percentageToString,
    productName: product?.name,
    productPrice: product?.price,
    productRetailPrice: product?.retailPrice,
    productUrl: product?.shopUrl,
    combines: product?.combines,
  };

  return details;
}
